/**
 * Terminal type for opening new terminal sessions
 */
export enum TerminalType {
  BUILTIN_XTERM = 'builtin_xterm',
  EXTERNAL_TERMINAL = 'external_terminal',
}
